import SectionManager from './SectionManager'

export default SectionManager
// eslint-disable-next-line import/export
export * from './SectionManager'
